import { render, staticRenderFns } from "./HoldOrderListDialog.vue?vue&type=template&id=380d6434&scoped=true"
import script from "./HoldOrderListDialog.vue?vue&type=script&lang=js"
export * from "./HoldOrderListDialog.vue?vue&type=script&lang=js"
import style0 from "./HoldOrderListDialog.vue?vue&type=style&index=0&id=380d6434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d6434",
  null
  
)

export default component.exports